import React from "react";
import FormGroupTextArea from "../formGroupTextArea";
import Button from "../button";
import CustomModal from "../General/customModal";

const CalendarModal = (props) => {
    const {} = props;

    return (
        <CustomModal
            isOpen={props.Store.modalCalendar}
            content={(
                <form
                    autoComplete={'off'}
                    className="form-horizontal"
                    onSubmit={(evt) => {
                        evt.preventDefault();
                        props.ChangeNewAppField('modalCalendar', '')
                    }}
                >
                    <FormGroupTextArea
                        centerWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                        Label={props.Store.modalCalendar.name}
                        required={true}
                        Name={props.Store.modalCalendar.id}
                        Value={props.Store.formData[props.Store.modalCalendar.id]}
                        HandleInputChange={props.HandleFormCompChange}
                    />
                    <div className="form-group">
                        <div className="col-sm-6 col-sm-offset-3">
                            <Button
                                wrapper="btn-wrapper"
                                btnType="submit"
                                btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                label="Save change"
                            />
                        </div>
                    </div>
                </form>
            )}
            handleClose={() => props.ChangeNewAppField('modalCalendar', '')}
        />
    )
};

export default CalendarModal;